var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElevator40PxSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "elevator",
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 55,
    r: 3,
    fill: "#FF2E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,48,34.142,33.521a19.531,19.531,0,0,0,5.474-10.054,19.315,19.315,0,0,0-1.138-11.345,19.725,19.725,0,0,0-7.367-8.813,20.309,20.309,0,0,0-22.222,0,19.725,19.725,0,0,0-7.367,8.813A19.315,19.315,0,0,0,.384,23.467,19.531,19.531,0,0,0,5.858,33.521Z",
    fill: "#FF2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.5,12.5)",
    fill: "#ffffff",
    d: "M11,1H4A1,1,0,0,0,3,2V13a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V2A1,1,0,0,0,11,1ZM7.5,12.5l-2-4h4Zm-2-6,2-4,2,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevator40PxSelected);
export default __webpack_public_path__ + "static/media/elevator_40px_selected.65390dff996add9f548ebcbe4e1fe6f7.svg";
export { ForwardRef as ReactComponent };